module.exports = __webpack_public_path__ + "media/images/Mask Group 1-743b56e5a544fcb292254159d83d7dd9.png";